import K from "@patsnap-biz/icon";
import "@patsnap-ui/icon/assets/solid/DropdownRight.svg";
import "@patsnap-ui/icon/assets/solid/DropdownOpen.svg";
import "@patsnap-ui/icon/assets/solid/3d.svg";
import "@patsnap-ui/icon/assets/solid/SpaceShared.svg";
import "@patsnap-ui/icon/assets/solid/company.svg";
import "@patsnap-ui/icon/assets/solid/FolderClosed2.svg";
import "@patsnap-ui/icon/assets/solid/autoFolder.svg";
import "@patsnap-ui/icon/assets/solid/LoadingBars.svg";
import "@patsnap-ui/icon/assets/solid/CheckboxOffNew.svg";
import "@patsnap-ui/icon/assets/solid/CheckboxOnNew.svg";
import "@patsnap-ui/icon/assets/solid/CloseSmallNew.svg";
import "@patsnap-ui/icon/assets/solid/CloseHoverSmallNew.svg";
import "@patsnap-ui/icon/assets/solid/CheckboxHalfNew.svg";
import "@patsnap-ui/icon/assets/solid/RadioOffNew.svg";
import "@patsnap-ui/icon/assets/solid/RadioOnNew.svg";
import "@patsnap-ui/icon/assets/solid/SmallDot.svg";
import { useI18n as O } from "vue-i18n";
import { ElCollapse as B, ElTooltip as R, ElCollapseItem as V, ElTree as H, ElInput as U } from "element-plus";
import "element-plus/es/components/collapse/style/css";
import "element-plus/es/components/collapse-item/style/css";
import "element-plus/es/components/input/style/css";
import "element-plus/es/components/tree/style/css";
import "element-plus/es/components/tooltip/style/css";
import { flatten as j, values as q, cloneDeep as m, debounce as G, omit as J, groupBy as Q } from "lodash";
import N from "@patsnap-biz/toast";
import { resolveComponent as W, openBlock as c, createElementBlock as a, normalizeClass as F, renderSlot as x, createElementVNode as h, createVNode as d, withCtx as k, Fragment as _, renderList as y, toDisplayString as f, withModifiers as C, withDirectives as w, vShow as b, createBlock as S, createCommentVNode as p, createTextVNode as T } from "vue";
import X from "lodash/isEmpty";
import Y from "lodash/cloneDeep";
const Z = {
  PtSelectWorkspace: {
    noData: "暂无数据",
    noWorkspace: "当前无工作空间。",
    noFolder: "该工作空间无文件夹，请尝试选择其他工作空间。",
    myWorkspace: "我的工作空间",
    sharedWorkspace: "来自分享的工作空间",
    publicWorkspace: "企业工作空间",
    selectWorkspace: "选择工作空间",
    navigationWorkspace: "导航库中心",
    selectAll: "全选",
    folderMaxLimit: "最多支持勾选{count}个文件夹",
    patentNumberLimit: "企业工作空间查找范围不可超过100万条记录，请缩小检索范围。",
    searchPlaceholder: "请选择或者搜索文件夹"
  }
}, $ = {
  PtSelectWorkspace: {
    noData: "No data",
    noWorkspace: "There are currently no workspace available.",
    noFolder: "No folder in this workspace, please choose another workspace.",
    myWorkspace: "My workspaces",
    sharedWorkspace: "Shared workspaces",
    publicWorkspace: "Company workspaces",
    selectWorkspace: "Select Workspace",
    navigationWorkspace: "Marketplace",
    selectAll: "Select All",
    folderMaxLimit: "Select up to {count} folders",
    patentNumberLimit: "The enterprise workspace search range cannot exceed 1 million records, please narrow the search range.",
    searchPlaceholder: "Please select or search for a folder"
  }
}, ee = {
  PtSelectWorkspace: {
    noData: "データ無し",
    noWorkspace: "まだワークスペースはありません。",
    noFolder: "このワークスペースにはフォルダがありません。ほかのワークスペースを選択してみてください。",
    myWorkspace: "私のワークスペース",
    sharedWorkspace: "共有のワークスペースから",
    publicWorkspace: "企業ワークスペース",
    selectWorkspace: "ワークスペースを選択",
    navigationWorkspace: "Marketplace",
    selectAll: "全て選択",
    folderMaxLimit: "最大{count}個のフォルダを選択することができます",
    patentNumberLimit: "エンタープライズ ワークスペースの検索範囲は 100 万件を超えることはできません。検索範囲を狭めてください。",
    searchPlaceholder: "フォルダを選択または検索してください"
  }
}, te = {
  PtSelectWorkspace: {
    noData: "暫無數據",
    noWorkspace: "當前無工作空間。",
    noFolder: "該工作空間無文件夾，請嘗試選擇其他工作空間。",
    myWorkspace: "我的工作空間",
    sharedWorkspace: "來自分享的工作空間",
    publicWorkspace: "企業工作空間",
    selectWorkspace: "選擇工作空間",
    navigationWorkspace: "導航庫中心",
    selectAll: "全選",
    folderMaxLimit: "最多支持勾選{count}個文件夾",
    patentNumberLimit: "企業工作空間查找範圍不可超過100萬條記錄，請縮小檢索範圍。",
    searchPlaceholder: "請選擇或者蒐索資料夾"
  }
}, se = (e, t) => {
  const s = e.__vccOpts || e;
  for (const [l, r] of t)
    s[l] = r;
  return s;
}, le = {
  name: "PtSelectWorkspace",
  components: {
    PtIcon: K,
    ElCollapse: B,
    ElTooltip: R,
    ElCollapseItem: V,
    ElTree: H,
    // PtTextTruncate,
    ElInput: U
  },
  props: {
    /**
     * 设置当前 workspace 和 folder
     */
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * 传入 SelectWorkspaceService
     */
    service: {
      type: Object
    },
    isShowPatentCount: {
      type: Boolean,
      default: !1
    },
    config: {
      type: Object,
      default() {
        return {
          multipleWorkspace: !1,
          showSearchBar: !1,
          patentLimitNumber: 0,
          renderType: "normal",
          showRefTarget: !0
        };
      }
    },
    /**
     * 同一个workspace下文件夹是否多选
     */
    multipleFolder: {
      type: Boolean,
      default: !1
    },
    /**
     * 在显示复选框的情况下，是否严格的遵循父子不互相关联的做法
     */
    checkStrictly: {
      type: Boolean,
      default: !0
    },
    /**
     * tree是否一直展开(tree直接展示在页面上)
     */
    isAlwaysUnfold: {
      type: Boolean,
      default: !1
    },
    /**
     * 文件夹多选时，文件可选择的最大数量
     */
    maxFolderCount: {
      type: Number,
      default: 0
    }
  },
  setup() {
    const { t: e } = O({
      messages: {
        cn: Z,
        en: $,
        jp: ee,
        tw: te
      },
      fallbackLocale: "cn"
    });
    return { t: e };
  },
  data() {
    return {
      loadingWorkspaces: !1,
      loadingFolders: !1,
      folders: [],
      currentWorkspace: void 0,
      folderTree: void 0,
      currentFolderSelect: {},
      currentWorkspaceId: void 0,
      currentFolderId: void 0,
      dropDownStatus: !1,
      activeName: "self",
      workspaceIconType: {
        self: "Solid3D",
        shared: "SolidSpaceShared",
        public: "SolidCompany",
        navigation: "Solid3D"
      },
      defaultProps: {
        children: "children",
        label: "folder_name"
      },
      AllWorkspaces: [],
      /**
       * 选中的文件夹列表
       */
      // folderSelectedList: [],
      // workspace 选中的folder数据表，key为workspaceId，value为folder列表
      folderSelectMap: {},
      /**
       * 全选按钮的状态，全选、半全选、没有选中
       */
      selectedAllFolderStateMap: {
        All: 0,
        HAS: 1,
        NONE: 2
      },
      /**
       * 默认选中的文件夹ID列表
       */
      defaultFolderIdList: [],
      keywords: ""
    };
  },
  computed: {
    folderSelectedList() {
      return j(q(this.folderSelectMap)) || [];
    },
    currentFolderSelectList() {
      return this.folderSelectMap[this.currentWorkspaceId] || [];
    },
    selectedAllFolderState() {
      return this.currentFolderSelectList.length === this.folders.length ? this.selectedAllFolderStateMap.All : this.currentFolderSelectList.length === 0 ? this.selectedAllFolderStateMap.NONE : this.selectedAllFolderStateMap.HAS;
    },
    selectResultLabel() {
      if (this.multipleFolder && this.folderSelectedList.length > 0 && this.currentWorkspace && this.currentWorkspace.space_name) {
        let e = m(this.currentWorkspace.space_name);
        return e.length > 16 && (e = `${e.slice(0, 16)}...`), this.folderSelectedList.map((s) => {
          let l = m(s.folder_name);
          return l.length > 16 && (l = `${l.slice(0, 16)}...`), `${e} /../ ${l}`;
        });
      }
      if (this.currentWorkspaceId && this.currentFolderId && this.currentFolderSelect && this.currentFolderSelect.folder_name && this.currentWorkspace && this.currentWorkspace.space_name) {
        let e = m(this.currentWorkspace.space_name);
        e.length > 16 && (e = `${e.slice(0, 16)}...`);
        let t = m(this.currentFolderSelect.folder_name);
        return t.length > 16 && (t = `${t.slice(0, 16)}...`), `${e} /../ ${t}`;
      }
      return this.t("PtSelectWorkspace.selectWorkspace");
    },
    selfValue() {
      let e = {};
      return this.multipleFolder ? e = {
        workspaceId: this.currentWorkspaceId,
        workspaceItem: this.currentWorkspace,
        folderSelectedList: this.folderSelectedList,
        defaultFolderIdList: this.defaultFolderIdList
      } : e = {
        workspaceId: this.currentWorkspaceId,
        folderId: this.currentFolderId,
        folderItem: this.currentFolderSelect,
        workspaceItem: this.currentWorkspace
      }, e;
    }
  },
  watch: {
    currentFolderId(e) {
      e && (this.dropDownStatus = !1);
    },
    value: {
      handler() {
      },
      deep: !0
    },
    selfValue: {
      handler(e) {
        this.$emit("input", e);
      },
      deep: !0
    },
    currentFolderSelectList() {
      this.updateTreeSetCheckedKeys();
    },
    keywords: G(function() {
      this.loadWorkspaces();
    }, 300),
    dropDownStatus() {
      this.$emit("updateDropStatus", this.dropDownStatus);
    }
  },
  beforeUnmount() {
    document.removeEventListener("click", this.close);
  },
  async mounted() {
    console.log(1111, this.$slots && this.$slots), this.isAlwaysUnfold && (this.dropDownStatus = !0), this.multipleFolder && !this.isAlwaysUnfold && document.addEventListener("click", this.close), this.decode(), await this.loadWorkspaces(), this.updateTreeSetCheckedKeys();
  },
  methods: {
    selectAllFolder() {
      if (this.currentFolderSelectList && this.currentFolderSelectList.length === this.folders.length)
        this.updateFolderSelectMap(this.currentWorkspaceId, null);
      else {
        const e = this.folders.length > this.maxFolderCount ? this.maxFolderCount : this.folders.length;
        if (!this.checkFoldersNumberLimit(this.folders, 0, !0) || !this.checkFoldersPatentNumberLimit(this.folders, 0, !0)) {
          this.updateTreeSetCheckedKeys();
          return;
        }
        const t = m(this.folders);
        this.updateFolderSelectMap(this.currentWorkspaceId, t.splice(0, e));
      }
      this.updateTreeSetCheckedKeys();
    },
    deleteFolder(e) {
      this.folderSelectMap[this.currentWorkspaceId].splice(e, 1), this.updateTreeSetCheckedKeys();
    },
    close(e) {
      this.$refs.selectWorkspace && this.dropDownStatus && (this.$refs.selectWorkspace.contains(e.target) || (this.dropDownStatus = !1));
    },
    decode() {
      const {
        workspaceId: e,
        folderId: t,
        folderSelectedList: s,
        defaultFolderIdList: l
      } = this.value;
      this.currentWorkspaceId = e, this.currentFolderId = t, this.defaultFolderIdList = l || [], this.multipleFolder && s && s.length && this.initMultipleWorkspaceFolderSelectMap(s);
    },
    kilo(e = 0) {
      return Number.isNaN(e) ? e : `${new Intl.NumberFormat("en-US", { style: "decimal" }).format(e)}`;
    },
    async loadWorkspaces() {
      this.loadingWorkspaces = !0;
      const e = await this.service.getWorkspaces(this.keywords).finally(() => {
        this.loadingWorkspaces = !1;
      });
      if (this.AllWorkspaces = [], e && (this.service.getMyWorkspaces().length > 0 && this.AllWorkspaces.push({
        type: "self",
        title: this.t("PtSelectWorkspace.myWorkspace"),
        workspaces: this.service.getMyWorkspaces()
      }), this.service.getSharedWorkspaces().length > 0 && this.AllWorkspaces.push({
        type: "shared",
        title: this.t("PtSelectWorkspace.sharedWorkspace"),
        workspaces: this.service.getSharedWorkspaces()
      }), this.service.getPublicWorkspaces().length > 0 && this.AllWorkspaces.push({
        type: "public",
        title: this.t("PtSelectWorkspace.publicWorkspace"),
        workspaces: this.service.getPublicWorkspaces()
      }), this.service.getNavigationWorkspaces().length > 0 && this.AllWorkspaces.push({
        type: "navigation",
        title: this.t("PtSelectWorkspace.navigationWorkspace"),
        workspaces: this.service.getNavigationWorkspaces()
      }), this.AllWorkspaces && this.AllWorkspaces.length > 0)) {
        let t = !1;
        if (this.currentWorkspaceId)
          for (let s = 0; s < this.AllWorkspaces.length; s += 1) {
            const l = this.AllWorkspaces[s];
            for (let r = 0; r < l.workspaces.length; r += 1) {
              const o = l.workspaces[r];
              if (o.space_id === this.currentWorkspaceId) {
                t = !0, this.activeName = l.type, this.currentWorkspace = o, this.currentWorkspaceId = o.space_id, this.$nextTick(() => {
                  const i = document.querySelectorAll(".patsnap-biz-select_workspace__workspace-item");
                  i && i[r] && i[r].scrollIntoView();
                });
                break;
              }
            }
            if (t)
              break;
          }
        if (t || (this.activeName = this.AllWorkspaces[0].type, this.currentWorkspace = this.AllWorkspaces[0].workspaces[0], this.currentWorkspaceId = this.currentWorkspace.space_id), await this.loadFolders(), this.currentFolderId) {
          const s = this.folders.findIndex((l) => l.folder_id === this.currentFolderId);
          s > -1 && (this.currentFolderSelect = { ...this.folders[s] }, this.$refs.tree.setCurrentKey(this.currentFolderId), this.scrollToFolderById(this.currentFolderId));
        }
        if (this.defaultFolderIdList && this.defaultFolderIdList.length > 0) {
          for (let s = 0; s < this.folders.length; s += 1) {
            const l = this.folders[s];
            this.defaultFolderIdList.findIndex((o) => l.folder_id === o) > -1 && this.multipleFolder && this.pushDataToFolderSelectMap({ ...l });
          }
          this.defaultFolderIdList = [];
        }
        this.currentFolderSelectList.length > 0 && this.$nextTick(() => {
          this.$refs.tree && (this.updateTreeSetCheckedKeys(null, this.handleCheckboxFolderNoStrictly), this.scrollToFolderById(this.currentFolderSelectList[0].folder_id));
        });
      }
    },
    scrollToFolderById(e) {
      const t = this.folders.findIndex((i) => i.folder_id === e), s = document.querySelector(".patsnap-biz-select_workspace__right"), l = document.querySelectorAll(".patsnap-biz-select_tree_item"), r = document.querySelector(".patsnap-biz-select_workspace__select-all"), o = r ? r.clientHeight : 0;
      if (s && l && l.length > 0) {
        const i = l[t];
        s.scrollTop = i.offsetTop + o;
      }
    },
    async loadFolders() {
      this.loadingFolders = !0;
      const e = await this.service.getFolders(this.currentWorkspaceId, this.keywords).finally(() => {
        this.loadingFolders = !1;
      });
      this.folders = [], this.folderTree = this.service.folderListToTree(e), this.handleFolder(m(this.folderTree));
    },
    handleFolder(e) {
      e.forEach((t) => {
        this.folders.push(t), t.children && this.handleFolder(t.children);
      });
    },
    handleClickWorkspace(e) {
      this.currentWorkspace = e, this.currentWorkspaceId = e.space_id, this.currentFolderSelect = !1, this.currentFolderId = "", this.currentFolderSelect = {}, this.multipleFolder && !this.config.multipleWorkspace && (this.folderSelectMap = {}, this.updateTreeSetCheckedKeys([])), this.loadFolders();
    },
    SwitchDropdown() {
      this.isAlwaysUnfold || (this.dropDownStatus = !this.dropDownStatus, this.dropDownStatus && this.currentFolderId && this.$refs.tree && this.$nextTick(() => {
        this.scrollToFolderById(this.currentFolderId);
      }));
    },
    /**
     * 文件夹多选时,点击文件夹前面的checkbox
     * @param data
     */
    handleCheckboxFolder(e) {
      if (!this.currentFolderSelectList)
        return;
      const t = this.currentFolderSelectList.findIndex((s) => s.folder_id === e.folder_id);
      if (t > -1)
        this.folderSelectMap[this.currentWorkspaceId].splice(t, 1), this.currentFolderSelectList.length || this.updateFolderSelectMap(this.currentWorkspaceId, null);
      else {
        if (!this.checkFoldersNumberLimit(this.currentFolderSelectList, 1) || !this.checkFoldersPatentNumberLimit(this.currentFolderSelectList, e.patent_count)) {
          this.updateTreeSetCheckedKeys();
          return;
        }
        this.pushDataToFolderSelectMap(e);
      }
      this.updateTreeSetCheckedKeys();
    },
    handleCheckboxFolderNoStrictly(e = {}) {
      if (!this.currentFolderSelectList || this.checkStrictly)
        return;
      const t = this.$refs.tree.getCheckedKeys(), s = this.folders.filter((l) => t.includes(l.folder_id));
      if (!this.checkFoldersNumberLimit(s, 0) || !this.checkFoldersPatentNumberLimit(s, 0)) {
        e.checked || this.updateFolderSelectMap(this.currentWorkspaceId, null), this.updateTreeSetCheckedKeys();
        return;
      }
      this.updateFolderSelectMap(this.currentWorkspaceId, s);
    },
    handleNodeClick(e, t) {
      if (!this.multipleFolder)
        this.currentFolderSelect = e, this.currentFolderId = e.folder_id;
      else {
        if (!this.checkStrictly) {
          this.handleCheckboxFolderNoStrictly(t);
          return;
        }
        this.handleCheckboxFolder(e);
      }
    },
    updateTreeSetCheckedKeys(e, t) {
      const l = (e || this.currentFolderSelectList).map((r) => r.folder_id);
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.tree && this.$refs.tree.setCheckedKeys(l), t && typeof t == "function" && t();
        }, 0);
      });
    },
    updateFolderSelectMap(e, t) {
      e && (t ? this.folderSelectMap = {
        ...this.folderSelectMap,
        [e || this.currentWorkspaceId]: [...t]
      } : this.folderSelectMap = J(this.folderSelectMap, [e]));
    },
    pushDataToFolderSelectMap(e) {
      this.folderSelectMap[this.currentWorkspaceId] ? this.folderSelectMap[this.currentWorkspaceId].push(e) : this.updateFolderSelectMap(this.currentWorkspaceId, [e]);
    },
    // 点击checkbox 勾选workspace
    handleSelectWorkspace(e) {
      if (this.config.multipleWorkspace)
        if (this.folderSelectMap[e.space_id])
          this.updateFolderSelectMap(e.space_id, null);
        else {
          if (!this.checkFoldersNumberLimit(this.folderSelectedList, 1) || !this.checkFoldersPatentNumberLimit(this.folderSelectedList, e.patent_count)) {
            this.updateTreeSetCheckedKeys();
            return;
          }
          this.updateFolderSelectMap(e.space_id, e.folder_info_simples || []);
        }
      else
        this.handleClickWorkspace(e);
    },
    /**
     * 检查文件夹数量是否满足限制要求，如果不满足，提示用户
     * true: 满足要求
     * false: 不满足要求
     */
    checkFoldersNumberLimit(e, t = 0) {
      return this.maxFolderCount > 0 && e.length + t > this.maxFolderCount ? (N({
        message: this.t("PtSelectWorkspace.folderMaxLimit", { count: this.maxFolderCount }),
        type: "error",
        showClose: !0
      }), !1) : !0;
    },
    /**
     * 检查专利数量是否满足限制要求，如果不满足，提示用户
     * true: 满足要求
     * false: 不满足要求
     */
    checkFoldersPatentNumberLimit(e, t = 0) {
      return this.config.patentLimitNumber > 0 && e.reduce((l, r) => l + r.patent_count, 0) + t > this.config.patentLimitNumber ? (this.initTipsToNode(), !1) : !0;
    },
    /**
     * workspace多选状态说明：
     * folderSelectMap 中的数据状态存在以下几种情况：
     * 1. 没有数据，表示没有勾选
     * 2. 有数据，但是数据与原始数据不一致，表示半选状态
     * 3. 有数据，且数据与原始数据一致，表示全选状态（workspace下fold list 可能为空，空数组对空数组也表示全选状态）
     *
     * workspace 单选状态说明：
     * 1. 当前workspaceId 与 选中的workspaceId 相同，表示选中
     * */
    getWorkspaceStatusIcon(e) {
      let t = "";
      if (this.config.multipleWorkspace) {
        const s = e.folder_info_simples || [], l = this.folderSelectMap[e.space_id];
        l ? l.length === s.length ? t = "SolidCheckboxOnNew" : t = "SolidCheckboxHalfNew" : t = "SolidCheckboxOffNew";
      } else
        t = this.currentWorkspaceId === e.space_id ? "SolidRadioOnNew" : "SolidRadioOffNew";
      return t;
    },
    initTipsToNode() {
      N({
        message: this.t("PtSelectWorkspace.patentNumberLimit"),
        type: "error",
        showClose: !0
      });
    },
    initMultipleWorkspaceFolderSelectMap(e) {
      const t = Q(e, (s) => s.space_id);
      this.folderSelectMap = m(t);
    },
    getHtmlStr(e) {
      if (!e)
        return "";
      if (!this.keywords)
        return e;
      const t = new RegExp(this.keywords, "gi");
      return e.replace(t, (l) => `<span class="sw-highlight">${l}</span>`);
    }
  }
}, re = {
  key: 0,
  class: "multiple-folder-label-list"
}, oe = { class: "multiple-folder-label" }, ce = { class: "multiple-folder-label-del" }, ie = { class: "multiple-folder-label" }, ae = { key: 1 }, ne = {
  key: 0,
  class: "patsnap-biz-select_workspace_search-bar-container"
}, de = {
  class: "patsnap-biz-select_workspace__main",
  "flex-item": "()",
  flex: "-"
}, pe = { class: "patsnap-biz-select_workspace__left" }, he = {
  key: 0,
  class: "patsnap-biz-select_workspace__no-data"
}, ue = {
  key: 1,
  class: "patsnap-biz-select_workspace__workspaces patsnap-ui-list"
}, fe = ["id", "onClick"], ke = ["workspace"], me = ["onClick"], _e = { class: "workspace-info" }, Se = { class: "text-truncate" }, We = {
  key: 0,
  class: "workspace_patent_count"
}, Fe = {
  class: "patsnap-biz-select_workspace__right",
  "flex-item": "()"
}, ge = {
  key: 0,
  flex: "o",
  class: "folder-loading"
}, ye = {
  key: 0,
  "flex-item": "center",
  class: "patsnap-biz-select_workspace__no-data"
}, we = ["id"], be = {
  key: 0,
  class: "patsnap-biz-select_item_checkbox"
}, Ie = { key: 1 }, Ce = { key: 2 }, Le = { class: "folderIcon" }, ve = { class: "folder-info" }, Ne = ["innerHTML"], xe = {
  key: 0,
  class: "folder_patent_count"
}, Te = {
  class: "patsnap-biz-select_workspace__main",
  flex: "-center"
}, Ae = {
  key: 0,
  "flex-item": "center",
  class: "patsnap-biz-select_workspace__no-data"
}, Me = {
  key: 1,
  "flex-item": "center",
  class: "loading"
};
function Pe(e, t, s, l, r, o) {
  const i = W("PtIcon"), g = W("ElTooltip"), A = W("el-input"), M = W("ElCollapseItem"), P = W("ElCollapse"), D = W("ElTree");
  return c(), a("div", {
    ref: "selectWorkspace",
    class: F(["patsnap-biz-select_workspace", { "is-multiple-folder": s.multipleFolder }]),
    flex: "|"
  }, [
    s.config.showRefTarget ? x(e.$slots, "default", {
      key: 0,
      data: { SwitchDropdown: o.SwitchDropdown }
    }, () => [
      h("div", {
        class: F(["patsnap-biz-select_workspace__top", {
          "patsnap-biz-select_workspace__has-select": r.currentWorkspaceId && r.currentFolderId
        }]),
        onClick: t[2] || (t[2] = (n) => o.SwitchDropdown())
      }, [
        s.multipleFolder && Array.isArray(o.selectResultLabel) && o.selectResultLabel.length > 0 ? (c(), a("span", re, [
          d(g, {
            placement: "top",
            "open-delay": 300,
            "visible-arrow": !1,
            "popper-class": "select-workspace-tooltip",
            effect: "light"
          }, {
            content: k(() => [
              (c(!0), a(_, null, y(o.currentFolderSelectList, (n) => (c(), a("div", {
                key: n.folder_id,
                class: "select-workspace-tooltip-folder-name"
              }, f(n.folder_name), 1))), 128))
            ]),
            default: k(() => [
              h("span", oe, [
                h("span", null, f(o.selectResultLabel[0]), 1),
                h("span", ce, [
                  d(i, {
                    icon: "SolidCloseSmallNew",
                    class: "multiple-folder-label-del-default",
                    onClick: t[0] || (t[0] = C((n) => o.deleteFolder(0), ["stop"]))
                  }),
                  d(i, {
                    icon: "SolidCloseHoverSmallNew",
                    class: "multiple-folder-label-del-hover",
                    onClick: t[1] || (t[1] = C((n) => o.deleteFolder(0), ["stop"]))
                  })
                ])
              ])
            ]),
            _: 1
          }),
          w(h("span", ie, [
            d(g, {
              placement: "top",
              "open-delay": 300,
              "visible-arrow": !1,
              "popper-class": "select-workspace-tooltip",
              effect: "light"
            }, {
              content: k(() => [
                (c(!0), a(_, null, y(o.currentFolderSelectList, (n) => (c(), a("div", {
                  key: n.folder_id
                }, f(n.folder_name), 1))), 128))
              ]),
              default: k(() => [
                h("span", null, "+" + f(o.selectResultLabel.length - 1), 1)
              ]),
              _: 1
            })
          ], 512), [
            [b, o.selectResultLabel.length > 1]
          ])
        ])) : (c(), a("span", ae, f(o.selectResultLabel), 1)),
        s.isAlwaysUnfold ? p("", !0) : (c(), a(_, { key: 2 }, [
          r.dropDownStatus ? p("", !0) : (c(), S(i, {
            key: 0,
            icon: "SolidDropdownOpen"
          })),
          r.dropDownStatus ? (c(), S(i, {
            key: 1,
            icon: "SolidDropdownClose"
          })) : p("", !0)
        ], 64))
      ], 2)
    ]) : p("", !0),
    w(h("div", {
      class: F(["patsnap-biz-select_workspace_container", `${s.config.renderType}-type`])
    }, [
      s.config.showSearchBar ? (c(), a("div", ne, [
        d(A, {
          modelValue: r.keywords,
          "onUpdate:modelValue": t[3] || (t[3] = (n) => r.keywords = n),
          placeholder: l.t("PtSelectWorkspace.searchPlaceholder")
        }, null, 8, ["modelValue", "placeholder"])
      ])) : p("", !0),
      w(h("div", de, [
        h("div", pe, [
          d(P, {
            modelValue: r.activeName,
            "onUpdate:modelValue": t[4] || (t[4] = (n) => r.activeName = n)
          }, {
            default: k(() => [
              (c(!0), a(_, null, y(r.AllWorkspaces, ({ title: n, type: L, workspaces: I }, z) => (c(), S(M, {
                key: z,
                name: L
              }, {
                title: k(() => [
                  d(i, {
                    icon: "SolidDropdownOpen",
                    class: "CollapseIcon open"
                  }),
                  d(i, {
                    icon: "SolidDropdownRight",
                    class: "CollapseIcon close"
                  }),
                  T(" " + f(n), 1)
                ]),
                default: k(() => [
                  I.length ? p("", !0) : (c(), a("div", he, f(l.t("PtSelectWorkspace.noData")), 1)),
                  I.length ? (c(), a("ul", ue, [
                    (c(!0), a(_, null, y(I, (u) => {
                      var v;
                      return c(), a("li", {
                        id: `id_${u.space_id}`,
                        key: u.space_id,
                        class: F([{
                          active: r.currentWorkspaceId === u.space_id
                        }, "patsnap-biz-select_workspace__workspace-item patsnap-ui-list-item"]),
                        onClick: (E) => o.handleClickWorkspace(u)
                      }, [
                        (v = e.slots) != null && v.workspace ? p("", !0) : (c(), a("div", {
                          key: 0,
                          name: "workspace",
                          class: "workspace-select-item",
                          workspace: u
                        }, [
                          s.multipleFolder ? (c(), a("span", {
                            key: 0,
                            class: "workspace-select-icon",
                            onClick: C((E) => o.handleSelectWorkspace(u), ["stop"])
                          }, [
                            d(i, {
                              icon: o.getWorkspaceStatusIcon(u),
                              class: F(["workspace-radio", { active: r.currentWorkspaceId === u.space_id }])
                            }, null, 8, ["icon", "class"])
                          ], 8, me)) : p("", !0),
                          d(i, {
                            icon: r.workspaceIconType[L],
                            class: "CollapseIcon open"
                          }, null, 8, ["icon"]),
                          d(g, {
                            placement: "top-start",
                            "open-delay": 300,
                            "visible-arrow": !1,
                            offset: "-5",
                            "popper-class": "select-workspace-tooltip",
                            content: s.isShowPatentCount ? `${u.space_name} (${o.kilo(u.total_patent_count)})` : u.space_name,
                            effect: "light"
                          }, {
                            default: k(() => [
                              h("div", _e, [
                                h("span", Se, f(u.space_name), 1),
                                s.isShowPatentCount ? (c(), a("span", We, "(" + f(o.kilo(u.total_patent_count)) + ")", 1)) : p("", !0)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["content"])
                        ], 8, ke)),
                        x(e.$slots, "workspace", { workspace: u })
                      ], 10, fe);
                    }), 128))
                  ])) : p("", !0)
                ]),
                _: 2
              }, 1032, ["name"]))), 128))
            ]),
            _: 3
          }, 8, ["modelValue"])
        ]),
        h("div", Fe, [
          r.loadingFolders ? (c(), a("div", ge, [
            d(i, { icon: "SolidLoadingBars" })
          ])) : p("", !0),
          r.loadingFolders ? p("", !0) : (c(), a(_, { key: 1 }, [
            !r.folderTree || r.folderTree.length === 0 ? (c(), a("div", ye, f(l.t("PtSelectWorkspace.noFolder")), 1)) : (c(), a(_, { key: 1 }, [
              !s.config.multipleWorkspace && s.multipleFolder && r.folderTree && r.folderTree.length > 0 ? (c(), a("div", {
                key: 0,
                class: "patsnap-biz-select_workspace__select-all",
                flex: "-",
                onClick: t[5] || (t[5] = (...n) => o.selectAllFolder && o.selectAllFolder(...n))
              }, [
                o.selectedAllFolderState === r.selectedAllFolderStateMap.All ? (c(), S(i, {
                  key: 0,
                  icon: "SolidCheckboxOnNew",
                  class: "patsnap-biz-select_item_checkbox-on"
                })) : o.selectedAllFolderState === r.selectedAllFolderStateMap.HAS ? (c(), S(i, {
                  key: 1,
                  icon: "SolidCheckboxHalfNew",
                  class: "patsnap-biz-select_item_checkbox-close"
                })) : (c(), S(i, {
                  key: 2,
                  icon: "SolidCheckboxOffNew",
                  class: "patsnap-biz-select_item_checkbox-off"
                })),
                T(" " + f(l.t("PtSelectWorkspace.selectAll")), 1)
              ])) : p("", !0),
              d(D, {
                ref: "tree",
                "default-expand-all": "",
                "node-key": "id",
                "expand-on-click-node": !1,
                data: r.folderTree,
                props: r.defaultProps,
                "check-strictly": s.checkStrictly,
                "show-checkbox": s.multipleFolder,
                "check-on-click-node": s.multipleFolder,
                onNodeClick: o.handleNodeClick
              }, {
                default: k(({ data: n }) => [
                  h("div", {
                    id: `id_${n.id}`,
                    class: "patsnap-biz-select_tree_item"
                  }, [
                    s.multipleFolder ? (c(), a("span", be, [
                      d(i, {
                        icon: "SolidCheckboxOffNew",
                        class: "patsnap-biz-select_item_checkbox-off"
                      }),
                      d(i, {
                        icon: "SolidCheckboxOnNew",
                        class: "patsnap-biz-select_item_checkbox-on"
                      })
                    ])) : p("", !0),
                    n.children ? (c(), a("span", Ie, [
                      d(i, {
                        icon: "SolidDropdownOpen",
                        class: "CollapseIcon open"
                      }),
                      d(i, {
                        icon: "SolidDropdownRight",
                        class: "CollapseIcon close"
                      })
                    ])) : (c(), a("span", Ce, [
                      s.multipleFolder ? (c(), S(i, {
                        key: 0,
                        icon: "SolidSmallDot",
                        class: "CollapseIcon patsnap-biz-select_item_small_dot"
                      })) : p("", !0)
                    ])),
                    h("span", Le, [
                      d(i, {
                        icon: n.folder_auto_update ? "SolidAutoFolder" : "SolidFolderClosed2"
                      }, null, 8, ["icon"])
                    ]),
                    d(g, {
                      placement: "top-start",
                      "open-delay": 300,
                      "visible-arrow": !1,
                      "popper-class": "select-workspace-tooltip",
                      content: s.isShowPatentCount ? `${n.folder_name} (${o.kilo(n.patent_count)})` : n.folder_name,
                      effect: "light"
                    }, {
                      default: k(() => [
                        h("div", ve, [
                          h("span", {
                            class: "folder_name",
                            innerHTML: o.getHtmlStr(n.folder_name)
                          }, null, 8, Ne),
                          s.isShowPatentCount ? (c(), a("span", xe, "(" + f(o.kilo(n.patent_count)) + ")", 1)) : p("", !0)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ], 8, we)
                ]),
                _: 1
              }, 8, ["data", "props", "check-strictly", "show-checkbox", "check-on-click-node", "onNodeClick"])
            ], 64))
          ], 64))
        ])
      ], 512), [
        [b, r.AllWorkspaces.length > 0 && !r.loadingWorkspaces]
      ]),
      w(h("div", Te, [
        !r.loadingWorkspaces && r.AllWorkspaces.length === 0 ? (c(), a("div", Ae, f(l.t("PtSelectWorkspace.noWorkspace")), 1)) : p("", !0),
        r.loadingWorkspaces ? (c(), a("div", Me, [
          d(i, { icon: "SolidLoadingBars" })
        ])) : p("", !0)
      ], 512), [
        [b, r.loadingWorkspaces || r.AllWorkspaces.length === 0]
      ])
    ], 2), [
      [b, r.dropDownStatus]
    ])
  ], 2);
}
const De = /* @__PURE__ */ se(le, [["render", Pe]]);
class pt {
  constructor() {
    this.workspaceList = {
      self: [],
      shared: [],
      public: []
    }, this.folderList = [];
  }
  /**
   * 返回 树结构的foldlist
   *
   * @returns
   */
  folderListToTree(t) {
    if (!t || !t.length)
      return [];
    const s = {};
    let l = t.map((o) => {
      const i = o;
      if (i.id = o.folder_id, o.parent_id !== "-root") {
        s[o.parent_id] || (s[o.parent_id] = { child: [] }), s[o.parent_id].child.push(o);
        return;
      }
      return o;
    });
    return l = l.filter((o) => o), this.mapChild(l, s);
  }
  // eslint-disable-next-line @typescript-eslint/default-param-last
  mapChild(t = [], s) {
    return t.map((l) => (s[l.folder_id] && (l.children = Y(s[l.folder_id].child), delete s[l.folder_id], X(s) || this.mapChild(l.children, s)), l)), t;
  }
  /**
   * 返回 discovery chart template catagories
   * @returns
   */
  async getWorkspaces() {
    return this.workspaceList = [], Promise.resolve(this.workspaceList);
  }
  getMyWorkspaces() {
    return this.workspaceList.self || [];
  }
  getSharedWorkspaces() {
    return this.workspaceList.shared || [];
  }
  getPublicWorkspaces() {
    return this.workspaceList.public || [];
  }
  getNavigationWorkspaces() {
    return this.workspaceList.navigation || [];
  }
  getAllWorkspaces() {
    return [].concat(
      this.getMyWorkspaces(),
      this.getSharedWorkspaces(),
      this.getPublicWorkspaces(),
      this.getNavigationWorkspaces()
    );
  }
  async getFolders() {
    return this.folderList = [], Promise.resolve(this.folderList);
  }
}
const ht = De;
export {
  ht as PtSelectWorkspace,
  pt as SelectWorkspaceService,
  ht as default
};
